// extracted by mini-css-extract-plugin
export var button = "transition-score-module--button--44744";
export var container = "transition-score-module--container--da35b";
export var iconBox = "transition-score-module--icon-box--c5b63";
export var img = "transition-score-module--img--e6bde";
export var preview = "transition-score-module--preview--4707a";